import bannerImage1 from "../../assets/img/bannerImage1.png";
import bannerImage2 from "../../assets/img/bannerImage2.png";
import bannerImage3 from "../../assets/img/bannerImage3.png";
import bannerImage4 from "../../assets/img/bannerImage4.png";
import bannerImage5 from "../../assets/img/bannerImage5.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper";

import "swiper/css";
import "swiper/css/pagination";

const TextBanner = () => {
  return (
    <>
      <Swiper
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Pagination, Autoplay, Navigation]}
        className="mySwiper"
        // autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={false}
      >
        <SwiperSlide>
          <section className="relative w-full lg:h-[90vh] h-[40vh] flex items-center">
            {/* Background Image */}
            <img
              src={bannerImage1}
              alt="Eurasia Food"
              className="absolute top-50 left-0 w-full h-full object-cover"
            />

            {/* Overlay */}
            {/* <div className="absolute top-0 left-0 w-full h-full bg-white/30"></div> */}

            {/* Content Box (Left Side) */}
            <div className="relative z-50 bg-white/80 pl-12 pr-8 lg:pl-48 lg:py-28 py-8 rounded-r-lg shadow-lg max-w-5xl text-left">
              <h1 className="text-2xl tracking-widest lg:text-5xl font-bold text-green-900 leading-snug">
                Founder Of <br /> Euro Foods Group
              </h1>
              <p className="mt-4 tracking-widest text-gray-700 text-lg">
                Building Bridges Through Food, Culture, and Innovation
              </p>
            </div>
          </section>
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <section className="relative w-full lg:h-[90vh] h-[40vh] flex items-center">
            {/* Background Image */}
            <img
              src={bannerImage2}
              alt="Eurasia Food"
              className="absolute top-0 left-0 w-full h-full object-cover"
            />

            {/* Overlay */}
            {/* <div className="absolute top-0 left-0 w-full h-full bg-white/30"></div> */}

            {/* Content Box (Left Side) */}
            <div className="relative z-10 bg-white/80 pl-12 pr-8 lg:pl-48 lg:py-28 py-8 rounded-r-lg shadow-lg max-w-5xl text-left">
              <h1 className="text-2xl tracking-widest lg:text-5xl font-bold text-green-900 leading-snug">
                EURASIA FOOD <br /> PROCESSING (BD) LTD.
              </h1>
              <p className="mt-4 tracking-widest text-gray-700 text-lg">
                Best Solution For Your Food
              </p>
            </div>
          </section>
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <section className="relative w-full lg:h-[90vh] h-[40vh] flex items-center">
            {/* Background Image */}
            <img
              src={bannerImage3}
              alt="Eurasia Food"
              className="absolute top-0 left-0 w-full h-full object-cover"
            />

            {/* Overlay */}
            {/* <div className="absolute top-0 left-0 w-full h-full bg-white/30"></div> */}

            {/* Content Box (Left Side) */}
            <div className="relative z-10 bg-white/80 pl-12 pr-8 lg:pl-48 lg:py-28 py-8 rounded-r-lg shadow-lg max-w-5xl text-left">
              <h1 className="text-2xl tracking-widest lg:text-5xl font-bold text-green-900 leading-snug">
                EURASIA FOOD <br /> PROCESSING (BD) LTD.
              </h1>
              <p className="mt-4 tracking-widest text-gray-700 text-lg">
                Best Solution For Your Food
              </p>
            </div>
          </section>
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <section className="relative w-full lg:h-[90vh] h-[40vh] flex items-center">
            {/* Background Image */}
            <img
              src={bannerImage4}
              alt="Eurasia Food"
              className="absolute top-0 left-0 w-full h-full object-cover"
            />

            {/* Overlay */}
            {/* <div className="absolute top-0 left-0 w-full h-full bg-white/30"></div> */}

            {/* Content Box (Left Side) */}
            <div className="relative z-10 bg-white/80 pl-12 pr-8 lg:pl-48 lg:py-28 py-8 rounded-r-lg shadow-lg max-w-5xl text-left">
              <h1 className="text-2xl tracking-widest lg:text-5xl font-bold text-green-900 leading-snug">
                EURASIA FOOD <br /> PROCESSING (BD) LTD.
              </h1>
              <p className="mt-4 tracking-widest text-gray-700 text-lg">
                Best Solution For Your Food
              </p>
            </div>
          </section>
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <section className="relative w-full lg:h-[90vh] h-[40vh] flex items-center">
            {/* Background Image */}
            <img
              src={bannerImage5}
              alt="Eurasia Food"
              className="absolute top-0 left-0 w-full h-full object-cover"
            />

            {/* Overlay */}
            {/* <div className="absolute top-0 left-0 w-full h-full bg-white/30"></div> */}

            {/* Content Box (Left Side) */}
            <div className="relative z-10 bg-white/80 pl-12 pr-8 lg:pl-48 lg:py-28 py-8 rounded-r-lg shadow-lg max-w-5xl text-left">
              <h1 className="text-2xl tracking-widest lg:text-5xl font-bold text-green-900 leading-snug">
                EURASIA FOOD <br /> PROCESSING (BD) LTD.
              </h1>
              <p className="mt-4 tracking-widest text-gray-700 text-lg">
                Best Solution For Your Food
              </p>
            </div>
          </section>
        </SwiperSlide>
      </Swiper>
    </>
  );
};

export default TextBanner;
